import React from 'react';

// Logo oficial de marca (badge rosa-polvo con GLAM / beauty studio).
// La imagen se amplía dentro de una caja que recorta el margen del badge: como el
// fondo del badge es rosa-polvo igual que el navbar/footer, el corte no se nota.
// `bare` usa la versión sin badge (letras blancas sobre transparente, misma geometría)
// para cuando el logo va directo sobre una foto.
function Logo({ className = 'h-14 md:h-16', bare = false }) {
  return (
    <span className={`block aspect-[1038/648] overflow-hidden ${className}`.trim()}>
      <img
        src={bare ? '/images/logo-glam-white.png' : '/images/logo-glam.png'}
        alt="GLAM beauty studio"
        width="1038"
        height="648"
        className="h-full w-full scale-[1.35] object-contain"
      />
    </span>
  );
}

export default Logo;
